import { render, staticRenderFns } from "./PaymentResultForm.vue?vue&type=template&id=1184a3fe&"
import script from "./PaymentResultForm.vue?vue&type=script&lang=js&"
export * from "./PaymentResultForm.vue?vue&type=script&lang=js&"
import style0 from "./PaymentResultForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports